import { render, staticRenderFns } from "./DiagnosticInformation.vue?vue&type=template&id=1dd295eb&"
import script from "./DiagnosticInformation.vue?vue&type=script&lang=ts&"
export * from "./DiagnosticInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports